"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Section;
exports.sectionStyle = exports.sectionOverflowVisible = exports.sectionOverflowHidden = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _react2 = require("@linaria/react");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _boxModelSize = require("@site/pattern-library-utils/box-model-size");
var tracking = _interopRequireWildcard(require("@site/pattern-library-utils/tracking"));
var _verticalSpacing = require("@site/pattern-library-utils/vertical-spacing");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const sectionOverflowVisible = exports.sectionOverflowVisible = "core-srry0sh";
const sectionOverflowHidden = exports.sectionOverflowHidden = "core-sxkv74n";
const sectionStyle = exports.sectionStyle = "core-s1804idb";
const SectionContainer = /*#__PURE__*/(0, _react2.styled)(_verticalSpacing.Layout)({
  name: "SectionContainer",
  class: "core-s1su50ie",
  vars: {
    "s1su50ie-0": [({
      textAlign
    }) => textAlign === 'center' ? textAlign : `flex-${textAlign}`],
    "s1su50ie-1": [({
      textAlign
    }) => textAlign]
  }
});

/**
 * @ignore @typedef {import('csstype').Property.TextAlign} TextAlign
 * @ignore @typedef {import('csstype').Property.BackgroundImage} BackgroundImage
 * @ignore @typedef {import('csstype').Property.BackgroundColor} BackgroundColor
 */
/**
 * Render section with content alignment.
 * @module Section
 *
 * @param {Object} props React props
 * @param {string} props.id content id, guid
 * @param {string} props.dataCy Override data-cy
 * @param {String} props.name a unique name for tracking the page element
 * @param {React.ReactElement|React.ReactElement[]} props.children content of section.
 * @param {BackgroundImage} [props.backgroundImage] Image url
 * @param {BackgroundColor} [props.backgroundColor] Background color
 * @param {TextAlign} [props.textAlign] Align start, center, end or inherit
 * @param {boolean} [props.invert] Invert colorscheme of section.
 * @param {String} props.padding padding enum
 * @param {String} props.margin padding enum
 * @param {String} props.verticalMargin Vertical Layout Outer Spacing Values
 * @param {String} props.verticalPadding Vertical Layout Inner Spacing Values
 * @param {String} props.className padding enum
 * @param {Object} props.style padding enum
 * @returns {React.ReactElement} section element
 * @public
 */
function Section({
  id,
  dataCy,
  partial,
  _name,
  children,
  textAlign = 'start',
  invert = false,
  backgroundColor,
  backgroundImage,
  padding = 'large',
  margin,
  style,
  className = '',
  showOverflow = false,
  verticalMargin,
  verticalPadding = 'none'
}) {
  const sectionOverflow = showOverflow ? sectionOverflowVisible : sectionOverflowHidden;
  return /*#__PURE__*/_react.default.createElement(SectionContainer, (0, _extends2.default)({
    id: id,
    "data-cy": dataCy,
    "data-partial": partial || (invert ? 'dark1' : ''),
    className: `${className} ${sectionStyle} ${sectionOverflow}`,
    "data-padding": padding,
    "data-margin": margin,
    textAlign: textAlign,
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding,
    style: {
      backgroundImage,
      backgroundColor,
      ...style
    }
  }, _name && {
    ...tracking.create(_name, false, true)
  }), children);
}
Section.propTypes = {
  id: _propTypes.default.string,
  dataCy: _propTypes.default.string.isRequired,
  partial: _propTypes.default.string,
  _name: _propTypes.default.string,
  invert: _propTypes.default.bool,
  textAlign: _propTypes.default.oneOf(['start', 'center', 'end']),
  padding: _propTypes.default.oneOf(['none', 'small', 'medium', 'large']),
  margin: _propTypes.default.oneOf(['none', 'small', 'large']),
  backgroundColor: _propTypes.default.string,
  backgroundImage: _propTypes.default.string,
  style: _propTypes.default.object,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  showOverflow: _propTypes.default.bool,
  ..._boxModelSize.marginProps,
  ..._boxModelSize.paddingProps
};